import React, { useState } from 'react';
import CheckAuth from '../../elements/checkAuth';
import Menu from '../../elements/Menu/menu';
import './testStyles.css'
import AddressInfoPage from './addressInfoPage';
import "./addressInfo.css"
import SearchByToAddr from './searchByToAddr';
import SearchByContract from './searchByContract';
import PageMode from '../../elements/PageMode/pageMode';

export default function AddressInfo () {
    const MODES = ['SCANNER', 'SCRAPING BY TXHASH', 'SCRAPING BY CONTRACT ADDRESS']

    const [state, setState] = useState({
        mode: 'SCANNER'
    });


    const modeHandler = async (event) => {
        const mode = event.target.value;        
        setState(state => { return({ ...state, mode, }); });
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeHandler } />
            <div style={state.mode === MODES[0]? {display: 'block'} : {display: 'none'}}>
                <AddressInfoPage/>
            </div>
            <div className='scrapping_table_wrap' style={state.mode === MODES[1]? {display: 'block'} : {display: 'none'}}>
                <SearchByToAddr/>
            </div>
            <div className='scrapping_table_wrap' style={state.mode === MODES[2]? {display: 'block'} : {display: 'none'}}>
                <SearchByContract/>
            </div>
        </>
    );
};
